export default error => {
  if (error.graphQLErrors && error.graphQLErrors.length) {
    // TODO
    // Toast user with API error message after handling it?
    console.error(error);
    throw error;
  }

  if (error.networkError) {
    // TODO
    // Send user back to check in page?
    // Toast user with connection issue message?
    console.error(error);
    throw error;
  }

  console.error(error);
  throw error;
};
